module.exports = __webpack_public_path__ + "img/23e12b19e1b550087112b31b8fa6da8f.svg";